var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: { "console-header": true } }, [
    _c("div", { staticClass: "con-box" }, [
      _c("div", { staticClass: "account" }, [
        _c("div", { staticClass: "flex-b nw" }, [
          _c("img", {
            staticClass: "photo",
            attrs: {
              src:
                _vm.authUser.imgPath && !_vm.isInDingTalk
                  ? _vm.fileOperShow(_vm.authUser.imgPath)
                  : "/images/web/login_user_icon.png",
              onerror: "this.src='/images/web/login_user_icon.png'"
            }
          }),
          _c("div", { staticClass: "moreInfo" }, [
            _vm.authUser.userStemFrom === -16 && !_vm.isInDingTalk
              ? _c("img", {
                  staticStyle: {
                    width: "20px",
                    height: "20px",
                    "margin-right": "5px"
                  },
                  attrs: { src: "/images/icon/dingIcon.png", alt: "" }
                })
              : _vm._e(),
            _c("span", { staticClass: "name" }, [
              _vm._v("\n              " + _vm._s(_vm.corpName) + "\n          ")
            ])
          ]),
          !_vm.isInDingTalk
            ? _c("i", {
                staticClass: "el-icon-caret-bottom",
                staticStyle: { "font-size": "24px" }
              })
            : _vm._e()
        ]),
        !_vm.isInDingTalk
          ? _c(
              "div",
              { staticClass: "comp-expand" },
              [
                _c("userChange", {
                  attrs: { users: _vm.consoleUsers, ywtAccountChoose: true },
                  on: { showExpandIcon: _vm.showExpandIcon }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      _c(
        "div",
        { staticStyle: { display: "flex", "justify-content": "flex-end" } },
        [
          _c(
            "div",
            { staticClass: "ls-sh" },
            [
              _c(
                "el-button",
                { staticClass: "backBZ", on: { click: _vm.turnBack } },
                [_vm._v("返回首页")]
              )
            ],
            1
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a0a7472", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a0a7472","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/header/userConsoleHeader.vue
// module id = LTaM
// module chunks = 2 3 6 8 15 16 18 19 20 21 22 25 37